const SET_GAME_ID = 'set_game_id'

export default {
  namespaced: true,
  state: {
    selectedGameId: null
  },
  mutations: {
    [SET_GAME_ID] (state, gameId) {
      state.selectedGameId = gameId
    },
  },
  actions: {
    async setGameId (context, input) {
      context.commit(SET_GAME_ID, input)
    },
  }
}

export { SET_GAME_ID }
